import React__default from 'react';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import { useTranslation, Trans } from 'react-i18next';
import KModal from '../../../KModal/index.js';
import KModalContentSection from '../../../KModal/KModalContentSection/index.js';
import KModalHeader from '../../../KModal/KModalHeader/index.js';
import { withSuspense } from '../../../withSuspense/index.js';
import BasketCard from '../../BasketCard/index.js';

var PREFIX = "BasketAddTo";
var classes = {
    list: "".concat(PREFIX, "-list"),
    link: "".concat(PREFIX, "-link")
};
var StyledKModal = styled(KModal)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["& .".concat(classes.list)] = {
            listStyle: "none",
            padding: theme.spacing(2, 0, 0, 0),
            margin: 0,
            display: "grid",
            gap: theme.spacing(2),
            alignItems: "stretch",
            gridTemplateColumns: "repeat(auto-fill, minmax(15rem, 1fr))"
        },
        _b["& .".concat(classes.link)] = {
            color: theme.palette.primary.main,
            fontFamily: theme.typography.fontFamily,
            fontWeight: "bold",
            textDecoration: "underline",
            padding: 0,
            margin: 0,
            display: "inline-block",
            border: "none",
            appearance: "none",
            background: "none",
            fontSize: "1rem",
            cursor: "pointer"
        },
        _b);
});
var BasketAddTo = function (_a) {
    var open = _a.open, _b = _a.close, close = _b === void 0 ? function () { } : _b, count = _a.count, basketList = _a.basketList, _c = _a.onSelectBasket, onSelectBasket = _c === void 0 ? function (_id) { } : _c, createBasket = _a.createBasket, backgroundSize = _a.backgroundSize, KIcon = _a.KIcon;
    var t = useTranslation("refront-components").t;
    if (!open) {
        return null;
    }
    return (React__default.createElement(StyledKModal, { open: open, onClose: close, header: React__default.createElement(KModalHeader, { onClose: close, title: t("components.basket.addto.header.label", { count: count }) }), className: clsx("BasketAdd"), testId: "BasketAddPopup" },
        React__default.createElement(KModalContentSection, { title: t("components.basket.addto.title.label", { count: count }), description: React__default.createElement(Trans, { t: t, i18nKey: "components.basket.addto.description.label", count: count },
                "or",
                React__default.createElement("button", { id: "createBasketButton", className: classes.link, onClick: createBasket, "data-testid": "createBasketButton" }, "create a new one"),
                "to add your selected assets") },
            React__default.createElement("ul", { className: classes.list }, basketList === null || basketList === void 0 ? void 0 : basketList.map(function (_a) {
                var id = _a.id, mediaCount = _a.mediaCount, title = _a.title, media = _a.media;
                return (React__default.createElement("li", { key: id },
                    React__default.createElement(BasketCard, { "data-testid": "BasketCard", image: media, count: mediaCount, title: title, onClick: function () { return onSelectBasket(id); }, backgroundSize: backgroundSize, id: id.toString(), KIcon: KIcon })));
            })))));
};
var index = withSuspense(BasketAddTo);

export { index as default };
//# sourceMappingURL=index.js.map
